module.exports = __webpack_public_path__ + "static/media/lr.7526268d.jpeg";